<template>
  <div class="wrapper">
    <h3 class="top-title">{{form.type ? '修改帮助文档:' : '修改研究报告:'}}</h3>
    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="简介" prop="summary">
        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="form.summary"></el-input>
      </el-form-item>
      <el-form-item label="缩略图" prop="picUrl">
        <el-input v-model="form.picUrl"></el-input>
        <div class="upload-demo">
          <div class="el-upload el-upload--text">
            <div class="el-upload-dragger">
              <div class="upload-content">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  <span>仅支持单文件</span>
                  <em href="javascript:;" class="file">
                    点击上传
                    <input
                      type="file"
                      id="imgFile"
                      name="file"
                      @change="handleFileChange('imgFile')"
                    />
                  </em>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!imgNameSrc" class="el-upload__tip" slot="tip">可上传png, jpg, jpeg 文件，且不超过2M</div>
          <div v-else class="el-upload__tip">
            <span>{{imgNameSrc}}</span>
            <span class="el-icon-close clear-upload" @click="handleClearFile('imgFile')"></span>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="内容链接" prop="content">
        <el-input v-model="form.content"></el-input>
        <div class="upload-demo">
          <div class="el-upload el-upload--text">
            <div class="el-upload-dragger">
              <div class="upload-content">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  <span>仅支持单文件</span>
                  <em href="javascript:;" class="file">
                    点击上传
                    <input type="file" id="file" name="file" @change="handleFileChange('file')" />
                  </em>
                </div>
              </div>
            </div>
          </div>
          <el-progress
            :text-inside="true"
            :stroke-width="18"
            :percentage="percentage"
            status="exception"
          ></el-progress>
          <div v-if="!fileNameSrc" class="el-upload__tip" slot="tip">可上传pdf件，且不超过20M</div>
          <div v-else class="el-upload__tip">
            <span>{{fileNameSrc}}</span>
            <span class="el-icon-close clear-upload" @click="handleClearFile('file')"></span>
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('form')">确认修改</el-button>
        <el-button @click="handleBack">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import http from "../utils/http";
import { MSG } from "../utils/utils";
import { uploadImgType, uploadPdfType } from "../utils/constant";
import uploadFile from "../utils/uploadFile";
import { Progress } from "element-ui";
export default {
  name: "EditReport",
  data() {
    return {
      interface: {
        saveReport: `/article/save`
      },
      form: {
        title: "",
        summary: "",
        picUrl: "",
        content: "",
        type: 1,
        id: ""
      },
      imgNameSrc: "",
      fileNameSrc: "",
      percentage: 0,
      rules: {
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
          { min: 1, max: 100, message: "请输入标题", trigger: "blur" }
        ],
        picUrl: [
          { required: true, message: "请输入图片地址", trigger: "blur" }
        ],
        content: [
          { required: true, message: "请输入文件地址", trigger: "blur" }
        ]
      }
    };
  },
  mounted() {
    this.form = this.$route.query;
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.handleCreateReport();
        } else {
          return false;
        }
      });
    },
    handleFileChange(id) {
      let uploadType = id == "file" ? uploadPdfType : uploadImgType;
      let filesize = id == "file" ? 20 : 2;
      let files = document.getElementById(id).files;
      let filename = file.name;
      uploadFile(files, uploadType, filesize).then(url => {
        if (id == "file") {
          this.fileNameSrc = filename;
          this.form.content = url;
          this.percentage = 100;
        } else {
          this.imgNameSrc = filename;
          this.form.picUrl = url;
        }
      });
    },
    handleClearFile() {},
    handleCreateReport() {
      http
        .post(this.interface.saveReport, {
          ...this.form
        })
        .then(response => {
          const { code, data, message } = response;
          if (code === 1) {
            MSG.success(message);
            this.$router.back();
          } else {
            MSG.error(message);
          }
        });
    },
    handleBack() {
      this.$router.back();
    }
  }
};
</script>
<style lang="scss">
.wrapper {
  background-color: #fff;
  width: 85%;
  margin: 0 auto;
  margin-top: 20px;
  padding: 20px;
  .top-title {
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
  }
}
.upload-demo {
  .el-upload--text {
    width: 100%;
    .el-upload-dragger {
      width: 100%;
      .upload-content {
        width: 200px;
        margin: 0 auto;
      }
    }
  }
  .clear-upload {
    margin-left: 20px;
    &:hover {
      color: #ff552e;
      cursor: pointer;
    }
  }
}
.el-upload__text {
  & > span {
    vertical-align: middle;
  }
}
.file {
  position: relative;
  display: inline-block;
  overflow: hidden;
  cursor: pointer;
  text-decoration: none;
  text-indent: 0;
  line-height: 20px;
  font-size: 14px;
  color: #ff552e;
  vertical-align: middle;
  &:hover {
    font-weight: bold;
  }
}
.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/articleUpdate.vue